import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { UserAgreement } from '/screens/';

export default function UserAgreementPage() {
  return (
    <>
      <Head>
        <meta name="keywords" content="loadsmart user agreement" />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="User agreement"
        description="User agreement at Loadsmart"
        canonical="https://loadsmart.com/user-agreement/"
        openGraph={{
          url: 'https://loadsmart.com/user-agreement/',
        }}
      />
      <UserAgreement />
    </>
  );
}
